import * as React from 'react';
import {Link} from "react-router-dom";
import {AppVersion, topWersja, typ} from "../../utilities/Utilities";

interface Props {
}

export const Footer = (props: Props) => {

    return <footer id={'footer'}>
        <div className={'container'}>
            <div className={'row'}>
                <div className={'col-6 text-left'}><small>{(typ === 1)? topWersja() : `v${AppVersion}`}</small></div>
                <div className={'col-6 text-right'}>
                    <a href={'http://merkurymarket.pl/'}><small>Przejdź do sklepu merkurymarket.pl</small></a></div>
            </div>
        </div>
    </footer>

}

Footer.defaultProps = {}

